import { render, staticRenderFns } from "./listInvestor.vue?vue&type=template&id=32f68b98&scoped=true"
import script from "./listInvestor.vue?vue&type=script&lang=js"
export * from "./listInvestor.vue?vue&type=script&lang=js"
import style0 from "./listInvestor.vue?vue&type=style&index=0&id=32f68b98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f68b98",
  null
  
)

export default component.exports